import React, { useEffect } from 'react';
import PortalSidebar, { NavItem } from './PortalSidebar';
import PortalHeader from './PortalHeader';
import { useAppStore } from '../../store/useAppStore';

interface Props {
  children: React.ReactNode;
  navItems: NavItem[];
  title: string;
  subtitle: string;
}

const PortalLayout: React.FC<Props> = ({ children, navItems, title, subtitle }) => {
  const { sidebarOpen, setSidebarOpen } = useAppStore();

  // Close sidebar on mobile when route changes
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768 && sidebarOpen) setSidebarOpen(false);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [sidebarOpen, setSidebarOpen]);

  return (
    <div style={{ display: 'flex', minHeight: '100vh', background: 'var(--bg-secondary)' }}>
      {/* Mobile overlay */}
      {sidebarOpen && (
        <div
          onClick={() => setSidebarOpen(false)}
          style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 199 }}
          className="sidebar-overlay"
        />
      )}

      <PortalSidebar navItems={navItems} title={title} subtitle={subtitle} />

      <div style={{
        flex: 1,
        marginLeft: sidebarOpen ? '260px' : '0',
        transition: 'margin-left 0.3s ease',
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        minWidth: 0,
      }}>
        <PortalHeader title={title} />
        <main style={{ flex: 1, padding: '1.5rem', maxWidth: '100%', overflowX: 'hidden' }}>
          <div className="fade-in">{children}</div>
        </main>
      </div>

      <style>{`
        @media (max-width: 768px) {
          div[style*="margin-left: 260px"] { margin-left: 0 !important; }
          .sidebar-overlay { display: block; }
        }
        @media (min-width: 769px) {
          .sidebar-overlay { display: none; }
        }
      `}</style>
    </div>
  );
};

export default PortalLayout;
